export class Filter {
  index : number;
  columnValue : string;
  operatorValue : string;
  expressionValue : string;
  editing? : boolean;
}